module.exports = __webpack_public_path__ + "img/petsmall2.43be14e5.svg";